module.exports = __webpack_public_path__ + "img/icon_emptyBox.17008e7a.svg";